export default __webpack_public_path__ + "static/2-0d69f16c2189757bafbe5cb090d26f9f.jpeg";